import { render, staticRenderFns } from "./ShowNotice.vue?vue&type=template&id=ed86ecf6&scoped=true&"
import script from "./ShowNotice.vue?vue&type=script&lang=js&"
export * from "./ShowNotice.vue?vue&type=script&lang=js&"
import style0 from "./ShowNotice.vue?vue&type=style&index=0&id=ed86ecf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed86ecf6",
  null
  
)

export default component.exports